import type { Board } from "../../board";
import { XY } from "../../xy";
import type { MultiTileThingCore } from "./multiTileThingCore";
import { MultiTileThingPart } from "./multiTileThingPart";

export class MultiTileThingController {
	private core: MultiTileThingCore;
	private parts: Set<MultiTileThingPart>;

	constructor(core: MultiTileThingCore, parts: Set<MultiTileThingPart> = new Set()) {
		this.core = core;
		this.parts = parts;
	}

	getThing(): MultiTileThingCore {
		return this.core;
	}

	getParts(): Set<MultiTileThingPart> {
		return this.parts;
	}

	getBottomLeftXY(): XY {
		let minX = Infinity;
		let minY = Infinity;

		for (const part of this.parts) {
			if (part.xy.x < minX) minX = part.xy.x;
			if (part.xy.y < minY) minY = part.xy.y;
		}

		return new XY(minX, minY);
	}

	getRenderAnchorXY(): XY {
		let minX = Infinity;
		let maxY = -Infinity;

		for (const part of this.parts) {
			if (part.xy.x < minX) minX = part.xy.x;
			if (part.xy.y > maxY) maxY = part.xy.y;
		}

		return new XY(minX, maxY);
	}

	removeAll(board: Board): void {
		for (const part of this.parts) {
			board.removeAtEndOfTurn(part);
		}
		board.removeAtEndOfTurn(this.core);
	}

	onProjectileHit(projectile: unknown): void {
		this.core.onProjectileHit(projectile);
	}

	static addToBoard(board: Board, core: MultiTileThingCore, positions: XY[]): MultiTileThingController {
		core.xy = positions[0];

		const controller = new MultiTileThingController(core);
		core.controller = controller;

		// Core must NOT occupy a cell — parts handle physical presence for all positions.
		// Adding the core to a cell causes double-bump when a part also occupies that cell.
		board.addNonPhysicalThing(core);

		for (let i = 0; i < positions.length; i++) {
			const part = new MultiTileThingPart(positions[i]);
			part.linkToController(controller);
			controller.parts.add(part);
			board.addThing(part);
		}

		return controller;
	}
}
